import actions from '../actions';

const setValue = (key, value) => ({type: actions.SET_VALUE, key, value});
const setSubValue = (key, payload) => ({
  type: actions.SET_SUB_VALUE,
  key,
  payload
});

export {setValue as default, setSubValue};
